<template>
  <div class="adabundle-switch-box">
    <label class="adb-switch">

        <input 
          type="checkbox" 
          :name="id" 
          value="on" 
          tabindex="-1"
        />
        <div class="switch">
          <!-- <span>Off</span> -->
          <!-- <span>{{ t.off.text }}</span> -->
          <span class="left-span">
            <div style="
                width: 1px;
                height: 12px;
                background: #d5d5d5;
            ">
            </div>
          </span>
          <!-- <span>On</span> -->
          <!-- <span>{{ t.on.text }}</span> -->
          <span class="right-span">
            <div style="
                width: 12px;
                height: 12px;
                border: 1px solid #d5d5d5;
                border-radius: 999em;
            ">
            </div>
          </span>
        </div>

        <!-- <input type="checkbox" :name="profile.id" value="on" tabindex="-1" />
        <span class="adb-slider"></span> -->
    </label>
</div>
</template>

<script>
export default {
  name: "AccessibilitySwitch",
  props: {
    id: {
      type: String,
      required: true
    },
    t: {
      type: Object,
      required: true
    }
  },
}
</script>
